import React, { useEffect } from "react";

import UserChat from "./user-chat";
import AiChat from "./ai-chat";
import ScrollableFeed from "react-scrollable-feed";
import LoadingCircle from "../../auction/component/loading";

function ChatContainer({ data, status, query, isFetching, error }) {
  
  return (
    <div className="my-8 h-[30rem] lg:h-[28rem]">
      <ScrollableFeed className=" scrollbar-thin scrollbar-thumb-primary scrollbar-track-slate-200 px-4 lg:px-8">
        {!data?.newUser && data?.length > 1 ? (
          [...data]?.reverse().map((e, index) => (
            <div key={index}>
              <AiChat data={e.role === "asistant" ? e : ""} />
              <UserChat data={e.role === "customer" ? e : ""} />
            </div>
          ))
        ) : data[0]?.newUser ? (
          <AiChat
            key={Math.random()}
            data={{
              content: "مرحبا بك, كيف يمكنني مساعدتك",
              created_at: new Date(),
              isLoading: false,
            }}
          />
        ) : (
          <div className="flex justify-center items-center h-full">
            <LoadingCircle />
          </div>
        )}
        {status ? (
          <div>
            <UserChat
              data={{
                content: query,
                created_at: new Date(),
              }}
            />
            <AiChat
              data={{
                content: "...",
                created_at: new Date(),
                isLoading: true,
              }}
            />
          </div>
        ) : (
          ""
        )}

        {error.status === 400 || data.length >= 60 ? (
          <div>
            <AiChat
              data={{
                content:
                  "لقد تم إستهلاك الباقة المجانية , قم بالإشتراك للحصول على المزيد من المساعدة",
                created_at: new Date(),
                isLoading: false,
              }}
            />
          </div>
        ) : error.status === 500 ? (
          <div>
            <UserChat
              data={{
                content: query,
                created_at: new Date(),
              }}
            />
            <AiChat
              data={{
                content: "⚠️ عفوا نواجه بعض الصعوبات الرجاء المحاولة مجدداً",
                created_at: new Date(),
                isLoading: false,
              }}
            />
          </div>
        ) : (
          ""
        )}
      </ScrollableFeed>
    </div>
  );
}

export default ChatContainer;
